import type { VoidFunctionComponent } from 'react';
import type { SBOMAnalysisDetails, SBOMAnalysisStatus } from '../../../../../shared/sbomSummary/sbomAnalysis';
import Flex from '../../../generic/Flex';
import styles from './SBOMAnalysis.module.less';
import { Icon, icons } from '../../../generic';
import { formatDate } from '../../../issues/IssueDetails/Status/utils';

type SBOMAnalysisItemProps = {
  item: SBOMAnalysisDetails;
};

const SBOMAnalysisItem: VoidFunctionComponent<SBOMAnalysisItemProps> = ({
  item,
}) => {
  return (
    <div>
      <Flex justify="flex-start" gap={5} className={styles.itemContainer}>
        <ItemIcon status={item.status} testId="sbom-analysis-item-icon" />
        <span className={styles.itemLabel}>
          {item.description}
        </span>
        <span className={styles.itemValue}>
          {item.description.endsWith('timestamp') && item.value ?
            `"${formatDate(item.value)}"`
            :
            item.value || '' }
        </span>
      </Flex>
    </div>
  );
};

export default SBOMAnalysisItem;

/**
 * Analysis Item: Icon Component
 */
type ItemIconProps = { status: SBOMAnalysisStatus, testId?: string };
const ItemIcon: VoidFunctionComponent<ItemIconProps> = ({
  status,
  testId,
}) => {
  const getClass = () => {
    switch (status) {
      case 'success':
        return styles.itemStatusSuccess;
      case 'error':
        return styles.itemStatusError;
      case 'unknown':
      default:
        return '';
    }
  };

  const getIcon = () => {
    switch (status) {
      case 'success':
        return icons.checkCircleO;
      case 'error':
        return icons.xCircle;
      case 'unknown':
      default:
        return icons.minusCircleO;
    }
  };

  return (
    <span className={getClass()} data-testid={testId}>
      <Icon icon={getIcon()} />
    </span>
  );
};
